export function userCountTextOf(count: number): string {
  return count === 1 ? '1 usuário' : `${count} usuários`;
}
